import { render, staticRenderFns } from "./textarea-field.vue?vue&type=template&id=6515bad8&scoped=true"
import script from "./textarea-field.vue?vue&type=script&lang=js"
export * from "./textarea-field.vue?vue&type=script&lang=js"
import style0 from "./textarea-field.vue?vue&type=style&index=0&id=6515bad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515bad8",
  null
  
)

export default component.exports